var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 5.5h10.2c.62 0 1.17.38 1.4.96l2.35 5.88c.1.24.15.5.15.76V17c0 .83-.67 1.5-1.5 1.5h-15c-.83 0-1.5-.67-1.5-1.5v-3.9c0-.26.05-.52.15-.76L5.5 6.46c.23-.58.78-.96 1.4-.96Zm.27 1.3-2.16 5.4h4.24c.36 0 .68.19.86.5l.55.95c.18.31.5.5.86.5h1.96c.36 0 .68-.19.86-.5l.55-.95c.18-.31.5-.5.86-.5h4.24l-2.16-5.4a.5.5 0 0 0-.47-.3H7.64a.5.5 0 0 0-.47.3ZM4.8 13.5V17c0 .11.09.2.2.2h14c.11 0 .2-.09.2-.2v-3.5h-3.6l-.4.7c-.36.62-1.02 1-1.73 1h-1.94c-.71 0-1.37-.38-1.73-1l-.4-.7H4.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.88bd6c9aa7525ca831ec31e7f8f78c41.svg";
export { ForwardRef as ReactComponent };